import React from 'react';
import Spinner from 'app/shared/spinners/spinner-15/spinner-15';
import { BoardColumn } from './column';
import styles from './board.module.css';

export const Board = ({
  columns = [],
  items = [],
  group_by = 'segment',
  loading = false,
  empty_text = 'No items',
  renderCard = () => null,
  onColumnAdd = null,
  add_column_key = null,
  draggable = false,
  onCardMove = () => {}
}) => {
  if (loading) return <Spinner />;

  const grouped = columns.reduce((acc, column) => {
    acc[column.key] = items
      .filter((item) => item[group_by] === column.key)
      .sort((a, b) => new Date(b.updated_on || 0) - new Date(a.updated_on || 0));
    return acc;
  }, {});

  const handleCardDrop = (item_id, target_column_key) => {
    const item = items.find((i) => String(i.id || i._id) === item_id);
    if (!item || item[group_by] === target_column_key) return;
    onCardMove(item, target_column_key);
  };

  return (
    <div className={styles.board}>
      {columns.map((column) => (
        <BoardColumn
          key={column.key}
          column={column}
          items={grouped[column.key] || []}
          empty_text={empty_text}
          renderCard={renderCard}
          onAdd={onColumnAdd && column.key === add_column_key ? onColumnAdd : null}
          draggable={draggable}
          onCardDrop={handleCardDrop}
        />
      ))}
    </div>
  );
};
